import http from '../utils/http'

// let request = '/api'
let request = ''

export function getIQ(){
    return http.get(`${request}/iq`)
}

export function getMultimediaByName(params, responseType){
    return http.get(`${request}/multimedia_public/`,params,responseType)
}

export function getMultimediaByArkID(ARKID, params, responseType){
    return http.get(`${request}/multimedia/${ARKID}`,params,responseType)
}